import { render } from "./OKRCheckerSideBar.vue?vue&type=template&id=5094e353&scoped=true&ts=true"
import script from "./OKRCheckerSideBar.vue?vue&type=script&lang=ts"
export * from "./OKRCheckerSideBar.vue?vue&type=script&lang=ts"

import "./OKRCheckerSideBar.vue?vue&type=style&index=0&id=5094e353&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5094e353"]])

export default __exports__